import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../config';
import './HomeBlogs.css';

const HomeBlogs = () => {
  const [blogs, setBlogs] = useState(window.__BLOGS_CACHE__ || []);
  const [loading, setLoading] = useState(!window.__BLOGS_CACHE__);
  const [loadingSlug, setLoadingSlug] = useState(null);

  useEffect(() => {
    fetch(getApiUrl('/blogs'))
      .then((res) => {
        if (!res.ok) throw new Error('API down');
        return res.json();
      })
      .then((data) => {
        const posts = Array.isArray(data) ? data : [];
        setBlogs(posts);
        window.__BLOGS_CACHE__ = posts;
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching blogs for home page:', err);
        setLoading(false);
      });
  }, []);

  const handleBlogClick = (e, slug) => {
    e.preventDefault();
    setLoadingSlug(slug);

    fetch(getApiUrl(`/blogs/${slug}`))
      .then((res) => {
        if (!res.ok) throw new Error('Failed to prefetch blog details');
        return res.json();
      })
      .then((data) => {
        if (!window.__BLOG_DETAIL_CACHE__) {
          window.__BLOG_DETAIL_CACHE__ = {};
        }
        window.__BLOG_DETAIL_CACHE__[slug] = data;
        setLoadingSlug(null);
        window.history.pushState({}, '', `/${slug}/`);
      })
      .catch((err) => {
        console.error('Error prefetching blog:', err);
        setLoadingSlug(null);
        window.history.pushState({}, '', `/${slug}/`);
      });
  };

  // 6 blogs in 2 rows (3 columns x 2 rows)
  const displayedBlogs = blogs.slice(0, 6);

  return (
    <section className="home-blogs" id="blogs" aria-label="Explore Useful Insights Through Our Blogs">
      <div className="home-blogs__container">
        {/* Header */}
        <div className="home-blogs__header">
          <span className="home-blogs__badge">Latest Articles</span>
          <h2 className="home-blogs__title">
            Explore Useful Insights Through Our Blogs
          </h2>
          <p className="home-blogs__subtitle">
            Read our informative articles, Quran learning guides, and practical tips for parents, kids, and adult learners.
          </p>
        </div>

        {/* 6 Blogs Grid (2 rows x 3 columns) */}
        {loading ? (
          <div className="home-blogs__grid">
            {Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className="home-blogs__skeleton-card">
                <div className="home-blogs__skeleton-img" />
                <div className="home-blogs__skeleton-body">
                  <div className="home-blogs__skeleton-line home-blogs__skeleton-title" />
                  <div className="home-blogs__skeleton-line home-blogs__skeleton-title-short" />
                  <div className="home-blogs__skeleton-line home-blogs__skeleton-desc" />
                  <div className="home-blogs__skeleton-line home-blogs__skeleton-desc-short" />
                  <div className="home-blogs__skeleton-line home-blogs__skeleton-btn" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="home-blogs__grid">
            {displayedBlogs.map((post) => {
              const imageUrl = post.image && post.image.startsWith('http')
                ? post.image
                : `${process.env.PUBLIC_URL}${post.image || '/assets/images/home-banner.jpg'}`;

              return (
                <a
                  key={post.id || post.slug}
                  href={`/${post.slug}/`}
                  onClick={(e) => handleBlogClick(e, post.slug)}
                  className="home-blogs__card-link"
                >
                  <article className="home-blogs__card">
                    <div className="home-blogs__card-img-wrap">
                      <img
                        src={imageUrl}
                        alt={post.title}
                        className="home-blogs__card-img"
                        loading="lazy"
                      />
                    </div>
                    <div className="home-blogs__card-content">
                      <h3 className="home-blogs__card-title">
                        {post.title}
                      </h3>
                      {post.excerpt && (
                        <p className="home-blogs__card-excerpt">
                          {post.excerpt}
                        </p>
                      )}
                      <div className="home-blogs__card-footer">
                        <span className="home-blogs__card-btn">
                          {loadingSlug === post.slug ? (
                            <>
                              Loading...
                              <span className="home-blogs__spinner" />
                            </>
                          ) : (
                            <>
                              Read Article
                              <svg className="home-blogs__card-btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.22 5.03a.75.75 0 111.06-1.06l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 11-1.06-1.06l4.168-4.17H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                              </svg>
                            </>
                          )}
                        </span>
                      </div>
                    </div>
                  </article>
                </a>
              );
            })}
          </div>
        )}

        {/* View All Blogs CTA */}
        <div className="home-blogs__cta-wrap">
          <a
            href="/blog/"
            onClick={(e) => {
              e.preventDefault();
              window.history.pushState({}, '', '/blog/');
            }}
            className="home-blogs__view-all-btn"
          >
            View All Blogs
            <svg className="home-blogs__view-all-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.22 5.03a.75.75 0 111.06-1.06l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 11-1.06-1.06l4.168-4.17H3.75A.75.75 0 013 10z" clipRule="evenodd" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HomeBlogs;
